import {UserCredits} from './user-credits';
import {ActivityPricing} from './activity-pricing';
import {CreditUsage} from './credit-usage';
import {BillingDetails} from './billing-details';
import {Invoice} from './invoice';

export class UserCreditBilling {
  userCredit: UserCredits;
  activityPricing: ActivityPricing;
  listCreditUsage: CreditUsage[];
  billingDetails: BillingDetails;
  listInvoice: Invoice[];
}



// WEBPACK FOOTER //
// ./src/models/Billing/user-credit-billing.ts